
<div class="flex h-auto pb-24 w-full gap-6 text-pet-color-text-2 pt-10 pb-10 flex-col items-center  overflow-y-auto px-4 lg:px-10">
    <div class="text-4xl w-full font-black text-center">
        Bienvenido a <span class="ext-pet-color-text-1 ml-1">PET</span><span class="text-red-600">24</span>
    </div>
    <div class="font-bold text-center text-xl">
        Desde aca podrás agendar consultas en tu veterinaria, revisar el historial de citas y gestionar tu cuenta.
    </div>
    <div class="text-2xl font-black w-full">
        Tus Próximas Citas
    </div>
    <button
    class="shadow-md shadow-slate-500 border border-solid border-white bg-pet-color-3 hover:bg-pet-color-3-1 text-white font-bold py-2 px-6 rounded-full flex items-center gap-2"
    (click)="test()">
    {{estado}}
</button>
    <ng-container *ngIf="(anuncioBool); else completeData">
        <div>
            <button (click)="confirmarApertura()"
            class="shadow-md shadow-slate-500 border border-solid border-white bg-pet-color-5 hover:bg-pet-color-color-5  text-white font-bold py-2 px-6 rounded-full flex items-center gap-2">
            Abrir Veterinaria
          </button>
        </div>
    </ng-container>
    <ng-template #completeData>
        <div>
            <button (click)="confirmarCierre()"
            class="shadow-md shadow-slate-500 border border-solid border-white bg-pet-color-danger-1 hover:bg-pet-color-danger-1 text-white font-bold py-2 px-6 rounded-full flex items-center gap-2">
            Cerrar veterinaria por hoy
          </button>
        </div>
    </ng-template>



   
    <div class="flex border gap-3 border-gray-300 w-full h-full px-2 py-4 rounded-md overflow-x-auto items-center lg:px-12" >
        <app-appointment *ngFor="let item of consultas" [consulta]="item">
        </app-appointment>
    </div>
    
</div>